import AjaxSpinner from './AjaxSpinner';
export default AjaxSpinner;